import { useLocation } from 'react-router-dom';
import { useGetCatalog } from '../../../../../services/modules/catalogs/catalogs.queries';

interface UseCatalogSnapshotDetailsParams {
  catalogId: string;
  isOfflineMode: boolean;
}

export const useCatalogSnapshotDetails = ({
  catalogId,
  isOfflineMode,
}: UseCatalogSnapshotDetailsParams) => {
  const { search } = useLocation();
  const catalogQuery = useGetCatalog({ id: catalogId, isOfflineMode }, { enabled: !!catalogId });

  return { name: catalogQuery.data?.name, search };
};
